// export const BASEURL = "http://localhost:5000";
// export const BASEURL = "https://seo-insights-uat-backend.thecreatorpreneur.in/";
export const BASEURL = "https://seo-insights-backend.thecreatorpreneur.in";
// export const BASEURL = "https://seo-insights-backend.netlify.app/";
